module.exports = __webpack_public_path__ + "img/4.673c687.jpg";